export default __webpack_public_path__ + "static/media/loading-backdrop.d2f2aeea.png";